export enum AquaValidationType {
  WARNING = 'WARNING',
  ERROR = 'ERROR',
}
